import service from "@/store/services/warehouses-service";

export const state = () => ({
  list: {},
  warehouse: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, warehouse) => {
    state.warehouse = warehouse;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((warehouse) => {
      commit("SET_RESOURCE", warehouse);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((warehouse) => {
      commit("SET_RESOURCE", warehouse);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((warehouse) => {
      commit("SET_RESOURCE", warehouse);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  warehouse: (state) => state.warehouse,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((warehouse) => ({
      id: warehouse.id,
      name: `${warehouse.name}`,
    }));
  },
};

const warehouses = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default warehouses;
